<script>
export default {
  name: "settingsCustomerIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <rect x="5" y="1" width="6" height="6" rx="3" stroke="#A2A5B9" />
    <path
      d="M14.167 12.1589C15.0486 13.5617 13.6579 15 12.0011 15C10.867 15 9.48771 15 8 15C6.51229 15 5.13298 15 3.99895 15C2.34209 15 0.951444 13.5617 1.83298 12.1589C3.01474 10.2782 5.33322 9 8 9C10.6668 9 12.9853 10.2782 14.167 12.1589Z"
      stroke="#A2A5B9"
    />
  </svg>
</template>

<style scoped></style>
